import { z } from "zod";

/**
 * Code ambassadeur indépendant des anciens coupons.
 *
 * Le frontend peut ne pas l'envoyer.
 * Une chaîne vide est transformée en undefined.
 */
const ambassadorCodeSchema = z.preprocess((value) => {
  if (typeof value === "string" && value.trim().length === 0) {
    return undefined;
  }

  return value;
}, z.string().trim().min(8).max(80).optional());

const commonPaymentFields = {
  rateId: z.string().trim().min(1),

  /**
   * Conservé uniquement pour les coupons historiques
   * de réduction administrative.
   *
   * Les nouveaux codes ambassadeur n'utilisent pas couponId.
   */
  couponId: z.string().trim().min(1).nullable().optional(),

  ambassadorCode: ambassadorCodeSchema,

  /**
   * Le contrôleur remplace toujours userId par l'identifiant
   * de l'utilisateur authentifié.
   */
  userId: z.string().trim().min(1),

  IdempotencyKey: z.string().trim().min(8).max(200),
};

export const payloadForPaymentIntendMomo = z
  .object({
    ...commonPaymentFields,

    contryCode: z.string().trim().min(1),

    phoneNumber: z.string().trim().min(5).max(30),
  })
  .strict();

export const payloadForPaymentIntendCard = z
  .object({
    ...commonPaymentFields,

    currency: z.string().trim().min(3).max(10),
  })
  .strict();

export type PayloadForPaymentIntendMomo = z.infer<typeof payloadForPaymentIntendMomo>;

export type PayloadForPaymentIntendCard = z.infer<typeof payloadForPaymentIntendCard>;
